import { render, staticRenderFns } from "./data33.vue?vue&type=template&id=8272a9ac&scoped=true&"
import script from "./data33.vue?vue&type=script&lang=js&"
export * from "./data33.vue?vue&type=script&lang=js&"
import style1 from "./data33.vue?vue&type=style&index=1&id=8272a9ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8272a9ac",
  null
  
)

export default component.exports